/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Tools_LedeInputs */

const en_platform_tools_lede = /** @type {(inputs: Platform_Tools_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same public data, with no key and no account, before you write any code.`)
};

const zh_hans1_platform_tools_lede = /** @type {(inputs: Platform_Tools_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同样的公开数据，无需密钥、无需账号，写代码之前就能先用起来。`)
};

const pt_br2_platform_tools_lede = /** @type {(inputs: Platform_Tools_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os mesmos dados públicos, sem chave e sem conta, antes de escrever qualquer código.`)
};

const es_platform_tools_lede = /** @type {(inputs: Platform_Tools_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los mismos datos públicos, sin clave y sin cuenta, antes de escribir una sola línea de código.`)
};

const fr_platform_tools_lede = /** @type {(inputs: Platform_Tools_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les mêmes données publiques, sans clé ni compte, avant d’écrire la moindre ligne de code.`)
};

const de_platform_tools_lede = /** @type {(inputs: Platform_Tools_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieselben öffentlichen Daten, ohne Schlüssel und ohne Konto, bevor du eine Zeile Code schreibst.`)
};

const ru_platform_tools_lede = /** @type {(inputs: Platform_Tools_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Те же публичные данные, без ключа и аккаунта, ещё до того, как вы напишете код.`)
};

const it_platform_tools_lede = /** @type {(inputs: Platform_Tools_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli stessi dati pubblici, senza chiave e senza account, prima di scrivere codice.`)
};

/**
* | output |
* | --- |
* | "The same public data, with no key and no account, before you write any code." |
*
* @param {Platform_Tools_LedeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_tools_lede = /** @type {((inputs?: Platform_Tools_LedeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Tools_LedeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_tools_lede(inputs)
	if (locale === "pt-BR") return pt_br2_platform_tools_lede(inputs)
	if (locale === "es") return es_platform_tools_lede(inputs)
	if (locale === "fr") return fr_platform_tools_lede(inputs)
	if (locale === "de") return de_platform_tools_lede(inputs)
	if (locale === "ru") return ru_platform_tools_lede(inputs)
	if (locale === "it") return it_platform_tools_lede(inputs)
	return en_platform_tools_lede(inputs)
});